<template lang="pug">
    div(class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;" :key="video.id" ref="videoEl")
        div(class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;")
            div(:class="asyncClass" videoFoam="true" style="height:100%;position:relative;width:100%")
                div(class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;")
                    img(ref="wistiaImage" :src="swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" onload="this.parentNode.style.opacity=1;" loading="lazy")
                    VideoSchema(:video="video")
</template>

<script>
import { intersectionObserverMixin } from '@/helpers/intersectionObserverMixin'
import VideoSchema from '@/components/videoSchema.vue'
import wistiaMixin from './mixin'

export default {
    components: {
        VideoSchema,
    },
    mixins: [wistiaMixin, intersectionObserverMixin],
    props: {
        video: {
            type: Object,
            required: true,
        },
    },
    computed: {
        swatch() {
            return `https://fast.wistia.com/embed/medias/${this.video.id}/swatch`
        },
        asyncClass() {
            return `wistia_embed seo=false wistia_async_${this.video.id}`
        },
    },
    watch: {
        'video.id'() {
            this.$nextTick(() => {
                this.observe(this.$refs.videoEl, this.loadWistiaVideo)
            })
        },
    },
    mounted() {
        this.observe(this.$refs.videoEl, this.loadWistiaVideo)
    },
}
</script>
